// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { TimezoneProvider } from "./context/TimezoneContext";

/* ---------- Patch globale fetch → sempre con Bearer ---------- */
import { patchFetchWithAuth } from "./services/fetchAuthPatch";
patchFetchWithAuth();
/* -------------------------------------------------------------- */

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <TimezoneProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </TimezoneProvider>
  </React.StrictMode>
);

// Misura performance (opzionale):
reportWebVitals();
